import "./TmbConfirmPlanni.scss";


import { useNavigate } from "react-router-dom";
import PrivatePagesWrapper from "components/PrivatePagesWrapper/PrivatePagesWrapper";

import { SuccessActivityConfirmation } from '../../../libs/raas-ui-react-components/src/components';
import { TmbConfirmPlanniLiterals } from "./TmbConfirmPlanni.utils";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getDataTmbActivities } from "pages/public/Planner/PlannerFlow.service";
import useSession from "hooks/useSession";
import { ICardTmbActivities } from "pages/public/Planner/PlannerFlow.model";
import { getLanguageTMB } from "pages/public/TmbDetailActivity/TmbDetailActivity.service";
import { removeTMBSummaryDetail, setIdTmbSelect } from "services/user/user.session.service";
declare const window: any;


export default function TmbConfirmPlanni() {
    const [t, i18n] = useTranslation("tmbConfirmPlanni");
    const [tTmb] = useTranslation("tmbPages");
    const navigate = useNavigate();
    const {  logged } = useSession();
    const   literalsTmb= {titleBanner:  tTmb("tmbPlanner.titleBanner"),tripDescription:tTmb("tmbPlanner.tripDescription"),seeMore:tTmb("tmbPlanner.seeMore"),}
    const [activitiesList, setActivitiesList] = useState<ICardTmbActivities>();
    let lenguage=""
    useEffect(() => {
        if (sessionStorage.getItem('raas-language') != lenguage) {
            lenguage = sessionStorage.getItem('raas-language') as any

            getTmbActivities(getLanguageTMB(i18n.language));
            removeTMBSummaryDetail()
        }
   
    }, [t]);

      const getTmbActivities=(lenguage:any)=>{

        getDataTmbActivities(logged,
        (response: any) => {
            setActivitiesList(response)
   
        },
        (err: any) => {


        }, lenguage,window.sessionStorage["raas-trip-mock"])
}

      //Funcion que recoge la activida seleccionada
      const goSeeMoreTmb = (e: any) => {
        if(e.detail){
            //Variable de session para saber que imagen hay que cargar en el detalle
            window.sessionStorage.setItem('raas-id-tmb-image-select', e.detail.image);
            setIdTmbSelect(e.detail.id);
            navigate("/detail-activy");
        }
    }
    return (
        <>
            <div className="confirm-container">
                <SuccessActivityConfirmation
                    literalsTmb={literalsTmb}
                    activitiesList={activitiesList}
                    onButtonEventClick={(ev: CustomEvent) => navigate(ev?.detail)}
                    literals={TmbConfirmPlanniLiterals(t)}
                    onNavigateSeeMore={goSeeMoreTmb}
                ></SuccessActivityConfirmation>
            </div>
            <PrivatePagesWrapper></PrivatePagesWrapper>
        </>
    );
}
